'use client'

import React from 'react'

import { Paragraph } from '../../../atoms/Typography/Typography.component'

import { generateIdFromText } from '@caffeina-siad/utils'

import * as S from '../PostBody.styles'

const PostBodyTitle = ({ title, showInIndex }) => {
  const id = showInIndex ? generateIdFromText(title.content) : null
  return (
    <S.BodyTitle as={Paragraph} forwardedAs={title.as} typo={title.typo} content={title.content} weight="medium" id={id} />
  )
}

export default PostBodyTitle
